import { BaseService } from "./baseService";

export type TProfileData = {
  firstName?: string;
  lastName?: string;
  email?: string;
  country?: string;
  [key: string]: any;
};

export type TUserProfile = {
  id: string;
  userId: string;
  gender?: string | null;
  profileData?: TProfileData | null;
  createdAt: string;
  updatedAt: string;
};

export type TUserProfileResponse = {
  data: TUserProfile;
};

export type TUserProfileBatchResponse = {
  data: TUserProfile[];
  count?: number;
};

export type TUpdateProfileBody = {
  gender?: string;
  profileData?: TProfileData;
};

const PROFILE_API_BASE_URL = "/api/profile";

export class ProfileService extends BaseService {
  constructor() {
    super(PROFILE_API_BASE_URL);
  }

  /**
   * Get single user profile by userId
   */
  getUserProfile(userId: string): Promise<TUserProfileResponse> {
    return this.fetchJSON(`/v1/users/${userId}`);
  }

  /**
   * Get multiple user profiles in a single batch request (max 100 userIds)
   */
  getUserProfilesBatch(userIds: string[]): Promise<TUserProfileBatchResponse> {
    if (!userIds || userIds.length === 0) {
      return Promise.resolve({ data: [] });
    }

    return this.fetchJSON("/v1/users/batch", {
      headers: {
        "Content-Type": "application/json"
      },
      method: "POST",
      body: JSON.stringify({ userIds: userIds.slice(0, 100) })
    });
  }

  /**
   * Create or update user profile
   */
  updateUserProfile(userId: string, body: TUpdateProfileBody): Promise<TUserProfileResponse> {
    return this.fetchJSON(`/v1/users/${userId}`, {
      headers: {
        "Content-Type": "application/json"
      },
      method: "PUT",
      body: JSON.stringify(body)
    });
  }

  /**
   * Get all user profiles
   */
  getAllUserProfiles(): Promise<TUserProfileBatchResponse> {
    return this.fetchJSON("/v1/users");
  }

  /**
   * Delete user profile
   */
  deleteUserProfile(userId: string): Promise<{ message: string }> {
    return this.fetchJSON(`/v1/users/${userId}`, {
      method: "DELETE"
    });
  }
}

export const profileService = new ProfileService();
